import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { IBasicStyledProps, Link } from '@notino/react-styleguide-v20';

import { Wrapper } from './styled';

interface INavigationLinkProps extends IBasicStyledProps {
  message: MessageDescriptor;
  href: string;
  onClick: (event?: React.MouseEvent) => void;
}

export const NavigationLink: React.FC<INavigationLinkProps> = ({ message, href, onClick, ...rest }) => (
  <Wrapper {...rest}>
    <Link href={href} onClick={onClick}>
      <FormattedMessage {...message} />
    </Link>
  </Wrapper>
);
